import { Component, Vue } from "vue-property-decorator";

@Component
export default class FormValidation extends Vue {
  // Validation methods return an empty string if valid or an error message string if invalid

  validateEmail(email: string): string {
    // "Unnecessary escape character: \[ (no-useless-escape)" warning
    // is incorrectly triggered by eslint on build
    // eslint-disable-next-line
    const regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    if (email && regex.test(String(email).toLowerCase())) {
      return "";
    }
    return "Please enter a valid email";
  }

  validateString(string: string, error = "Please fill in this field"): string {
    if (string) {
      return "";
    }
    return error;
  }

  validateNumber(number: number | null, error = "Please fill in a number"): string {
    if (number) {
      return "";
    }
    return error;
  }
}
